import { Navigation, ChevronRight, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Banner shown when the courier has active deliveries — clickable, scrolls to the list.
 * Also exports the low-credit warning banner.
 */
export const ActiveDeliveriesBanner = ({ activeOrders, onScrollToOrders }) => {
  if (!activeOrders || activeOrders.length === 0) return null;
  return (
    <div
      onClick={onScrollToOrders}
      className="bg-gradient-to-r from-[#003594] via-[#003594] to-[#003594] border-2 border-[#D4AF37]/40 rounded-[2rem] p-5 cursor-pointer hover:scale-[1.01] transition-transform shadow-2xl shadow-[#003594]/40"
      data-testid="active-deliveries-banner"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <div className="relative flex-shrink-0">
            <div className="w-14 h-14 rounded-2xl bg-[#D4AF37] flex items-center justify-center shadow-lg shadow-[#D4AF37]/30">
              <Navigation className="w-7 h-7 text-[#0F172A]" />
            </div>
            <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-red-500 text-white text-[10px] font-black flex items-center justify-center border-2 border-[#003594] animate-pulse">
              {activeOrders.length}
            </span>
          </div>
          <div className="min-w-0">
            <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#D4AF37]">
              Vos livraisons en cours
            </p>
            <p className="text-base md:text-lg font-black text-white truncate">
              {activeOrders.length} commande{activeOrders.length > 1 ? "s" : ""} active
              {activeOrders.length > 1 ? "s" : ""} · #
              {activeOrders[0].id.substring(0, 8).toUpperCase()}
            </p>
            <p className="text-[10px] text-white/70 font-bold uppercase tracking-widest mt-0.5 truncate">
              Tapez pour voir la liste complète ↓
            </p>
          </div>
        </div>
        <ChevronRight size={24} className="text-[#D4AF37] flex-shrink-0" />
      </div>
    </div>
  );
};

export const LowCreditBanner = ({ creditBalance, onRecharge }) => {
  if (creditBalance >= 500) return null;
  return (
    <div
      className="rounded-[2rem] border border-red-500/40 bg-red-500/10 p-4 flex items-center gap-4"
      data-testid="low-credit-banner"
    >
      <div className="w-11 h-11 rounded-xl bg-red-500/20 text-red-400 flex items-center justify-center flex-shrink-0">
        <Wallet className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-black text-red-300 uppercase tracking-widest">
          Crédit insuffisant ({creditBalance.toLocaleString()} FCFA)
        </p>
        <p className="text-[10px] text-red-200/80 mt-1">
          Vous ne pouvez plus recevoir de nouvelles commandes.
        </p>
      </div>
      <Button
        onClick={onRecharge}
        className="bg-red-500 hover:bg-red-600 text-white rounded-full text-xs font-black uppercase tracking-widest"
        data-testid="low-credit-recharge-btn"
      >
        Recharger
      </Button>
    </div>
  );
};
